module.exports = __webpack_public_path__ + "img/fi-rr-ping-pong.d8fe8080.svg";